import * as React from 'react';

import { Count } from '@/components/atoms/Count';
import { formatBadgeCount } from '@/components/molecules/BellIcon/BellIcon';

/**
 * NotificationCountPill (WEB-635) — unread affordance for the nav-menu
 * Notifications row (Definitive `390 authed menu`).
 *
 * Omitted entirely at zero unread (never renders `0`). Cap display at `99+`
 * via the shared `formatBadgeCount` helper so the menu pill and retired bell
 * badge stay consistent.
 *
 * WEB-1020 (operator ruling 2026-09-30): a bare unread number is the DS
 * `Count` atom — 20 high, solid `--nav-unread` fill, `--bg` ink, tabular
 * figures — not a hand-skinned badge.
 */

export interface NotificationCountPillProps {
  /** Server-authoritative unread count from `useGetUnreadCountQuery`. */
  readonly count: number;
  readonly className?: string;
}

export function NotificationCountPill({
  count,
  className,
}: NotificationCountPillProps): React.ReactElement | null {
  if (count <= 0) return null;

  return (
    <Count data-testid="notification-count-pill" className={className}>
      {formatBadgeCount(count)}
    </Count>
  );
}
